import { render, staticRenderFns } from "./vueTablePagination.vue?vue&type=template&id=99f9a7fc&scoped=true"
import script from "./vueTablePagination.vue?vue&type=script&lang=js"
export * from "./vueTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f9a7fc",
  null
  
)

export default component.exports